module.exports = __webpack_public_path__ + "img/logoNetflixOriginal.6a70ee9f.png";